import http from "../http";
import Service from "../../Service";

export default class ClientsProfilesService extends Service {
    LIST_PATH = "v2/commons/profiles";

    list(params = {}) {
        return http.get(this.LIST_PATH, {
            headers: this.getHeaders(),
            params,
        });
    }

    save(profile) {
        return profile.id ? this.update(profile) : this.create(profile);
    }

    create(profile) {
        return http.post(this.LIST_PATH, profile, {
            headers: this.getHeaders(),
        });
    }

    update(profile) {
        return http.put(`${this.LIST_PATH}/${profile.id}`, profile, {
            headers: this.getHeaders(),
        });
    }

    remove(profile) {
        return http.delete(`${this.LIST_PATH}/${profile.id}`, {
            headers: this.getHeaders(),
        });
    }

    save_permission(permission) {
        return this.create_permission(permission);
    }

    create_permission(permission) {
        return http.post(
            `${this.LIST_PATH}/${permission.profile_id}/permissions`,
            permission,
            { headers: this.getHeaders() }
        );
    }

    update_permission(permission) {
        return http.put(
            `${this.LIST_PATH}/${permission.profile_id}/permissions/${permission.id}`,
            permission,
            { headers: this.getHeaders() }
        );
    }

    remove_permission(permission) {
        return http.delete(
            `${this.LIST_PATH}/${permission.profile_id}/permissions/${permission.id}`,
            { headers: this.getHeaders() }
        );
    }
}
